import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllEmbedsAPI ,getAllMediaAPI} from "../../routes/apiEndPoints";
import { API_REQUEST } from ".";

// fetch-embeds
export const fetchEmbeds = createAsyncThunk("fetch-embeds", async()=>{
    try{
 const response = await API_REQUEST({
    url: getAllEmbedsAPI,
    method: "GET",
  });
  return response;
    }catch (error) { }

})

// fetch-media
export const fetchMedia = createAsyncThunk("fetch-media", async()=>{
    try{
 const response = await API_REQUEST({
    url: getAllMediaAPI,
    method: "GET",
  });
  return response;
    }catch (error) { }

})